/**
 * Handles all focus to anchor
 * @module focus to
 */
import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
import Keyboard from './keyboard';
// Expose the function as a jQuery plugin for ease of uses
export const PLUGIN_NAME = 'focusTo';
export const DEFAULTS = {};

/**
 * Scrolls to element
 * @param {HTMLElement} $target - element sending focus to
 */
const scrollToElement = ($target, scrollPosOffset = 0) => {
  const focusBool = Keyboard.isFocusable($target);
  const nonFocusElement = $target[0];
  if (!focusBool) {
    nonFocusElement.setAttribute('tabindex', '-1');
    nonFocusElement.focus();
  }

  const focusActive = $('html').hasClass('focus-active');
  if (focusActive) {
    $('html, body')
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top - 6,
        },
        400
      );
  } else {
    $('html, body')
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top - scrollPosOffset - 0,
        },
        400
      );
  }
};

/**
 * Initiates Focus / Scroll
 * @param {jQuery} $el - button /element that opens focusTo
 * @param {object} evt - event object
 */

function focusStart($el, evt) {
  evt.preventDefault(evt);
  const hash = $el[0].hash;
  const $target = $(hash);
  const $mainElement = $('main');

  [$mainElement, $target].forEach(($targetedSegment) => {
    if ($targetedSegment.length > 0) {
      $targetedSegment[0].focus({ preventScroll: true });
      scrollToElement($targetedSegment);
    }
  });
}

/**
 * Handles Event Listeners.
 * @param {jQuery} $el - button /element that opens focusTo
 */
function setEventListeners($el) {
  $el.on('click', function (evt) {
    focusStart($el, evt);
  });
}

/**
 * Initializes focusTo.
 * @param {HTMLElement} el - button /element that opens focusTo
 * @param {Object} options - Options used for wiring up the focusTo
 * @see DEFAULTS
 */
export default function focusTo(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, focusTo);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/focus-to.js